/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/anchor-is-valid */
import EditFilterModal from 'components/atoms/edit_filter_modal';
import React, { useEffect, useState } from 'react';
import IconDuvidas from '../../../assets/images/icon-duvidas.svg';

interface ViewFilterProps {
  dadosFilters: any;
  setShowEditModal: React.Dispatch<React.SetStateAction<boolean>>;
  showEditModal: boolean;
  usuarios: Array<string>;
}

const ViewFilter = (props: ViewFilterProps) => {
  const { dadosFilters, setShowEditModal, showEditModal, usuarios } = props;
  const [users, setUsers] = useState<string>('');
  const [palavraChave, setPalavraChave] = useState<string>('');
  const [palavraChaveFollowup, setPalavraChaveFollowup] = useState<string>('');
  console.log(
    dadosFilters?.licitacao?.find((d: any) => d?.palavra_chave)?.palavra_chave?.is_negation,
  );
  useEffect(() => {
    setUsers(
      dadosFilters?.users
        .filter(Boolean)
        ?.map((user: any) => ` ${user?.nome}`)
        .join(', '),
    );

    const licitacaoPalavrasChave = dadosFilters?.licitacao
      .map((filtro: any) => filtro?.palavra_chave?.values)
      .filter(Boolean);
    const acompanhamentoPalavrasChave = dadosFilters?.acompanhamento
      .filter((filtro: any) => filtro?.palavra_chave)
      ?.map((filtro: any) => filtro?.palavra_chave?.values)
      .filter(Boolean);

    setPalavraChave(licitacaoPalavrasChave.join(', '));
    setPalavraChaveFollowup(acompanhamentoPalavrasChave.join(', '));
  }, []);

  return (
    <div className="col-md-12 px-0 py-3 px-md-3">
      <div className="card">
        <div className="card-header">
          <div className="row">
            <div className="col-md-12 p-0">
              <h3 className="card-title m-2">{dadosFilters?.nome_filtro}</h3>{' '}
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-12">
              <div className="p-2 mb-2 bg-dark text-white">Usuários</div>
              {users.toString()}
              {dadosFilters?.licitacao?.length && (
                <>
                  <div className="p-2 mb-2 bg-dark text-white mt-3">Licitações</div>
                  <div className="row mt-4">
                    <div className="col-md-3">Período</div>
                    <div className="col-md-9">
                      {Array(dadosFilters?.periodos).map((home: any) => (
                        <div>
                          {home.manha && 'Manhã'}, {home.tarde && 'Tarde'}, {home.noite && 'Noite'}
                        </div>
                      ))}
                    </div>
                  </div>
                  <hr />
                  <div>
                    <div className="row mt-4">
                      <div className="col-md-3">Segmentos</div>
                      <div className="col-md-9">
                        <ul
                          className="mb-0 pl-3"
                          style={{ listStyleType: 'disc', paddingLeft: '1rem' }}
                        >
                          {dadosFilters?.licitacao.map((filtro: any, index: number) => (
                            <React.Fragment key={index}>
                              {filtro?.atividades?.values.map((value: string, i: number) => (
                                <li key={`${index}-${i}`}>{value}</li>
                              ))}
                            </React.Fragment>
                          ))}
                        </ul>
                      </div>
                    </div>
                    <hr />
                    <div className="row mt-4">
                      <div className="col-md-3">
                        Estados
                        {dadosFilters?.licitacao?.find((d: any) => d?.estados)?.estados
                          ?.is_negation && (
                          <div
                            className="databalloon d-inline-block"
                            data-balloon-length="large"
                            aria-label="Se uma licitação conter os termos deste filtro, ela não será exibida para você."
                          >
                            <span className="ml-3 bg-secondary d-inline-block text-white px-1 rounded">
                              Não enviar
                              <img
                                className="ml-1"
                                src={IconDuvidas}
                                alt="Icone de dúvidas (?)"
                                width="10"
                                height="10"
                              />
                            </span>
                          </div>
                        )}
                      </div>
                      <div className="col-md-9">
                        {dadosFilters?.licitacao.length &&
                        !dadosFilters?.licitacao.some(
                          (licitacao: any) => licitacao.estados?.values?.length,
                        ) ? (
                          <span>Nacional</span>
                        ) : (
                          dadosFilters?.licitacao.map((licitacao: any, index: number) => (
                            <React.Fragment key={index}>
                              <strong>{licitacao.estados?.is_negation && 'Não enviar: '}</strong>
                              {licitacao.estados?.values?.join(', ')}
                            </React.Fragment>
                          ))
                        )}
                      </div>
                    </div>
                    <hr />
                    <div className="row mt-4">
                      <div className="col-md-3">
                        Cidades
                        {dadosFilters?.licitacao?.find((d: any) => d?.cidades)?.cidades
                          ?.is_negation && (
                          <div
                            className="databalloon d-inline-block"
                            data-balloon-length="large"
                            aria-label="Se uma licitação conter os termos deste filtro, ela não será exibida para você."
                          >
                            <span className="ml-3 bg-secondary d-inline-block text-white px-1 rounded">
                              Não enviar
                              <img
                                className="ml-1"
                                src={IconDuvidas}
                                alt="Icone de dúvidas (?)"
                                width="10"
                                height="10"
                              />
                            </span>
                          </div>
                        )}
                      </div>
                      <div className="col-md-9">
                        {dadosFilters?.licitacao.map((licitacao: any, index: number) => (
                          <React.Fragment key={index}>
                            <strong>{licitacao.cidades?.is_negation && 'Não enviar: '}</strong>
                            {licitacao.cidades?.values?.join(', ')}
                          </React.Fragment>
                        ))}
                      </div>
                    </div>
                    <hr />
                    <div className="row mt-4">
                      <div className="col-md-3">
                        Tipo orgão
                        {dadosFilters?.licitacao?.find((d: any) => d?.tipo_de_orgao)?.tipo_de_orgao
                          ?.is_negation && (
                          <div
                            className="databalloon d-inline-block"
                            data-balloon-length="large"
                            aria-label="Se uma licitação conter os termos deste filtro, ela não será exibida para você."
                          >
                            <span className="ml-3 bg-secondary d-inline-block text-white px-1 rounded">
                              Não enviar
                              <img
                                className="ml-1"
                                src={IconDuvidas}
                                alt="Icone de dúvidas (?)"
                                width="10"
                                height="10"
                              />
                            </span>
                          </div>
                        )}
                      </div>
                      <div className="col-md-9">
                        {dadosFilters?.licitacao
                          .filter(Boolean)
                          ?.map((index: number) =>
                            dadosFilters?.licitacao[index]?.tipo_de_orgao?.values?.map(
                              (orgao: string) => `${orgao}, `,
                            ),
                          )}
                      </div>
                    </div>
                    <hr />
                    {palavraChave && (
                      <div className="row mt-4">
                        <div className="col-md-3">
                          Palavras-Chaves
                          {dadosFilters?.licitacao?.find((d: any) => d?.palavra_chave)
                            ?.palavra_chave?.is_negation && (
                            <div
                              className="databalloon d-inline-block"
                              data-balloon-length="large"
                              aria-label="Se uma licitação conter os termos deste filtro, ela não será exibida para você."
                            >
                              <span className="ml-3 bg-secondary d-inline-block text-white px-1 rounded">
                                Não enviar
                                <img
                                  className="ml-1"
                                  src={IconDuvidas}
                                  alt="Icone de dúvidas (?)"
                                  width="10"
                                  height="10"
                                />
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="col-md-9">
                          <textarea
                            className="form-control"
                            id="segmento"
                            name="segmento"
                            rows={3}
                            value={palavraChave}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </>
              )}
              {dadosFilters?.acompanhamento?.length && (
                <>
                  <div className="p-2 mb-2 bg-dark text-white mt-3">Acompanhamentos</div>
                  <div className="row mt-4">
                    <div className="col-md-3">Segmentos</div>
                    <div className="col-md-9">
                      <ul style={{ listStyleType: 'disc', paddingLeft: '1rem' }}>
                        {dadosFilters?.acompanhamento[0]?.atividades?.values?.map(
                          (value: string, index: number) => (
                            <li key={index}>{value}</li>
                          ),
                        )}
                      </ul>
                    </div>
                  </div>

                  <hr />
                  <div className="row mt-4">
                    <div className="col-md-3">
                      Estados
                      {dadosFilters?.acompanhamento?.find((d: any) => d?.estados)?.estados
                        ?.is_negation && (
                        <div
                          className="databalloon d-inline-block"
                          data-balloon-length="large"
                          aria-label="Se uma licitação conter os termos deste filtro, ela não será exibida para você."
                        >
                          <span className="ml-3 bg-secondary d-inline-block text-white px-1 rounded">
                            Não enviar
                            <img
                              className="ml-1"
                              src={IconDuvidas}
                              alt="Icone de dúvidas (?)"
                              width="10"
                              height="10"
                            />
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="col-md-9">
                      {dadosFilters?.acompanhamento.length &&
                      !dadosFilters?.acompanhamento.some(
                        (acomp: any) => acomp.estados?.values?.length,
                      ) ? (
                        <span>Nacional</span>
                      ) : (
                        dadosFilters?.acompanhamento.map((acomp: any, index: number) => (
                          <React.Fragment key={index}>
                            <strong>
                              {dadosFilters?.acompanhamento[index]?.estados?.is_negation &&
                                'Não enviar: '}
                            </strong>
                            {acomp.estados?.values?.join(', ')}
                          </React.Fragment>
                        ))
                      )}
                    </div>
                  </div>
                  <hr />
                  <div className="row mt-4">
                    <div className="col-md-3">
                      Cidades
                      {dadosFilters?.acompanhamento?.find((d: any) => d?.cidades)?.cidades
                        ?.is_negation && (
                        <div
                          className="databalloon d-inline-block"
                          data-balloon-length="large"
                          aria-label="Se uma licitação conter os termos deste filtro, ela não será exibida para você."
                        >
                          <span className="ml-3 bg-secondary d-inline-block text-white px-1 rounded">
                            Não enviar
                            <img
                              className="ml-1"
                              src={IconDuvidas}
                              alt="Icone de dúvidas (?)"
                              width="10"
                              height="10"
                            />
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="col-md-9">
                      {dadosFilters?.acompanhamento.map((acomp: any, index: number) => (
                        <React.Fragment key={index}>
                          <strong>{acomp?.cidades?.is_negation && 'Não enviar: '}</strong>
                          {acomp.cidades?.values?.join(', ')}
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                  <hr />
                  {palavraChaveFollowup !== '' && (
                    <>
                      <div className="row mt-4">
                        <div className="col-md-3">
                          Palavras-Chaves
                          {dadosFilters?.acompanhamento?.find((d: any) => d?.palavra_chave)
                            ?.palavra_chave?.is_negation && (
                            <div
                              className="databalloon d-inline-block"
                              data-balloon-length="large"
                              aria-label="Se uma licitação conter os termos deste filtro, ela não será exibida para você."
                            >
                              <span className="ml-3 bg-secondary d-inline-block text-white px-1 rounded">
                                Não enviar
                                <img
                                  className="ml-1"
                                  src={IconDuvidas}
                                  alt="Icone de dúvidas (?)"
                                  width="10"
                                  height="10"
                                />
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="col-md-9">
                          <textarea
                            className="form-control"
                            id="segmento"
                            name="segmento"
                            rows={3}
                            value={palavraChaveFollowup}
                          />
                        </div>
                      </div>
                      <hr />
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {dadosFilters?.length !== 0 && (
        <EditFilterModal
          setShowEditModal={setShowEditModal}
          showEditModal={showEditModal}
          dataFilter={dadosFilters}
          users_filter={usuarios}
        />
      )}
    </div>
  );
};

export default ViewFilter;
